/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, Interface } from "ethers";
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "accountAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "enum IContractDeployer.AccountNonceOrdering",
                name: "nonceOrdering",
                type: "uint8",
            },
        ],
        name: "AccountNonceOrderingUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "accountAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "enum IContractDeployer.AccountAbstractionVersion",
                name: "aaVersion",
                type: "uint8",
            },
        ],
        name: "AccountVersionUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "deployerAddress",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "bytecodeHash",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "contractAddress",
                type: "address",
            },
        ],
        name: "ContractDeployed",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_salt",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "_bytecodeHash",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_input",
                type: "bytes",
            },
        ],
        name: "create",
        outputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_salt",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "_bytecodeHash",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_input",
                type: "bytes",
            },
        ],
        name: "create2",
        outputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_salt",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "_bytecodeHash",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_input",
                type: "bytes",
            },
            {
                internalType: "enum IContractDeployer.AccountAbstractionVersion",
                name: "_aaVersion",
                type: "uint8",
            },
        ],
        name: "create2Account",
        outputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_salt",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "_bytecodeHash",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_input",
                type: "bytes",
            },
            {
                internalType: "enum IContractDeployer.AccountAbstractionVersion",
                name: "_aaVersion",
                type: "uint8",
            },
        ],
        name: "createAccount",
        outputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_address",
                type: "address",
            },
        ],
        name: "getAccountInfo",
        outputs: [
            {
                components: [
                    {
                        internalType: "enum IContractDeployer.AccountAbstractionVersion",
                        name: "supportedAAVersion",
                        type: "uint8",
                    },
                    {
                        internalType: "enum IContractDeployer.AccountNonceOrdering",
                        name: "nonceOrdering",
                        type: "uint8",
                    },
                ],
                internalType: "struct IContractDeployer.AccountInfo",
                name: "info",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_sender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_senderNonce",
                type: "uint256",
            },
        ],
        name: "getNewAddressCreate",
        outputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_sender",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_bytecodeHash",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "_salt",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_input",
                type: "bytes",
            },
        ],
        name: "getNewAddressCreate2",
        outputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum IContractDeployer.AccountAbstractionVersion",
                name: "_version",
                type: "uint8",
            },
        ],
        name: "updateAccountVersion",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum IContractDeployer.AccountNonceOrdering",
                name: "_nonceOrdering",
                type: "uint8",
            },
        ],
        name: "updateNonceOrdering",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
export class IContractDeployer__factory {
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
IContractDeployer__factory.abi = _abi;
//# sourceMappingURL=IContractDeployer__factory.js.map